<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 19a7 7 0 100-14 7 7 0 000 14z"/></svg>